import { render } from "./PageBanner.vue?vue&type=template&id=df7a2ef2"
import script from "./PageBanner.vue?vue&type=script&lang=js"
export * from "./PageBanner.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/releases/52/app.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QCard,QIcon});
